import { Building2, Database, ScrollText } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type FatoSeguranca = { titulo: string; texto: string; icone: LucideIcon };

/**
 * TRÊS fatos, não oito — o corte foi decisão do dono (2026-09-03): a seção
 * media 3.830px no celular, 24% da página, um contrato dentro da landing.
 * Ficaram os três que VENDEM para contador; senha, sessão, papel no servidor
 * e afins continuam verdadeiros e continuam nos Termos — a landing não é o
 * lugar do inventário. Nenhuma certificação inventada, como sempre.
 */
export const FATOS_SEGURANCA: readonly FatoSeguranca[] = [
  {
    icone: Building2,
    titulo: 'Isolamento por escritório',
    texto:
      'Todo dado carrega o tenant do escritório e toda consulta filtra por ele — vindo do token, nunca da requisição. Há teste que tenta forjar por baixo da tela, e a API ignora.',
  },
  {
    icone: ScrollText,
    titulo: 'Nenhum modelo de linguagem no ato',
    texto:
      'O texto do contrato é determinístico: o mesmo cadastro produz sempre o mesmo documento. Todo LLM ficou fora do caminho jurídico, por decisão de projeto.',
  },
  {
    icone: Database,
    titulo: 'O dado é seu, sempre',
    texto:
      'Exportável a qualquer momento, removido a pedido — o dado é do escritório, não da Specializer.',
  },
] as const;
